import { Radio, Wind, Feather, HelpCircle, Leaf } from "lucide-react";

export const CHANNEL_META = {
  all: { icon: Radio, label: { fr: "Toutes les ondes", en: "All waves", es: "Todas las ondas", nl: "Alle golven" } },
  silence: { icon: Wind, label: { fr: "Silence", en: "Silence", es: "Silencio", nl: "Stilte" } },
  liberte: { icon: Feather, label: { fr: "Liberté", en: "Freedom", es: "Libertad", nl: "Vrijheid" } },
  doute: { icon: HelpCircle, label: { fr: "Doute", en: "Doubt", es: "Duda", nl: "Twijfel" } },
  nature: { icon: Leaf, label: { fr: "Nature", en: "Nature", es: "Naturaleza", nl: "Natuur" } },
};

export const ChannelPicker = ({ channels, current, onPick, lang }) => (
  <div className="flex flex-wrap gap-2 mb-6" role="tablist" data-testid="radio-channel-picker">
    {Object.entries(CHANNEL_META).map(([id, m]) => {
      const Icon = m.icon;
      const active = id === current;
      const count = id === "all" ? null : channels?.[id]?.length;
      return (
        <button key={id} onClick={() => onPick(id)} role="tab" aria-selected={active} data-testid={`radio-channel-${id}`}
          className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm border transition-colors ${active ? "bg-primary/20 border-primary/60 text-primary" : "bg-white/[0.03] border-white/10 text-foreground/70 hover:border-primary/40 hover:text-foreground"}`}>
          <Icon size={14} /> {m.label[lang] || m.label.fr}
          {count ? <span className="text-[0.65rem] text-foreground/40 tabular-nums">{count}</span> : null}
        </button>
      );
    })}
  </div>
);
